/* eslint-disable no-console */
import React, { Component } from 'react';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// our components
import { CURRENCY_FILTER } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import { Mutation } from 'components/common/Query';
import CurrencyFilterForm from 'components/CurrencyFilter/Form';

/**
 * Mutation to create an currency filter
 */
export const CREATE_CURRENCY_FILTER_MUTATION = gql`
  mutation($currency: CreateCurrencyFilterFormCurrency!, $rate: Float!) {
    createCurrencyFilter(input: { currency: $currency, rate: $rate }) {
      currencyFilter {
        id
        __typename
      }
      errors {
        field
        messages
        __typename
      }
      clientMutationId
      __typename
    }
  }
`;

/**
 * @class
 * @extends Component
 */
class CurrencyFilterCreateContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.Compose = adopt({
      mutateCurrencyFilterCreate: this.currencyFilterCreate,
    });
  }

  /**
   * @description
   * Mutation callback to compose with list query.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  currencyFilterCreate = ({ render }) => (
    <Mutation
      mutation={CREATE_CURRENCY_FILTER_MUTATION}
      onCompleted={this.currencyFilterCreateCompleted}
    >
      {handleCurrencyFilterCreate => render({ handleCurrencyFilterCreate })}
    </Mutation>
  );

  /**
   * @description
   * Mutation callback when create currency filter is completed.
   *
   * @param {Object} createAd - Mutation result.
   */
  currencyFilterCreateCompleted = async ({ createCurrencyFilter }) => {
    const history = this.context;
    const { errors } = createCurrencyFilter;
    if (!errors) {
      history.push(CURRENCY_FILTER.LIST);
    } else {
      this.setState({ errors });
    }
  };

  /**
   * @description
   * Close notification.
   * @returns {undefined} - No returns value.
   */
  handleCloseNotification = () => {
    this.setState({ errors: [] });
  };

  /**
   * @description
   * Render CurrencyFilterForm component.
   *
   * @returns {*} Component to render.
   */
  render() {
    const { errors } = this.state;
    return (
      <this.Compose>
        {({ mutateCurrencyFilterCreate: { handleCurrencyFilterCreate } }) => (
          <CurrencyFilterForm
            currencyFilterSave={currencyFilter =>
              handleCurrencyFilterCreate({ variables: currencyFilter })
            }
            errors={errors}
            closeNotification={this.handleCloseNotification}
          />
        )}
      </this.Compose>
    );
  }
}

export default CurrencyFilterCreateContainer;
